import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(p) => p.theme.colors.white};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  border-radius: 0.8rem;
  padding: 2rem;
  margin-bottom: 2rem;
  transition: opacity 0.3s ease;

  &.blur {
    opacity: 0.6;
    pointer-events: none;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
`

export const Title = styled.div`
  ${(p) => p.theme.bold}
  font-size: 1.8rem;
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 40rem;

  ${(p) => p.theme.mQ.MEDIA_MAX_MEDIUM} {
    height: 30rem;
  }
`

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40rem;
  font-size: 1.4rem;
  color: ${(p) => p.theme.colors.greyDark};
`
